import { render } from "./SteamCopyright.vue?vue&type=template&id=3e510f8e"
const script = {}

import "./SteamCopyright.vue?vue&type=style&index=0&id=3e510f8e&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__